import { render, staticRenderFns } from "./home-page.vue?vue&type=template&id=52a51003&scoped=true&"
import script from "./home-page.vue?vue&type=script&lang=js&"
export * from "./home-page.vue?vue&type=script&lang=js&"
import style0 from "./home-page.vue?vue&type=style&index=0&id=52a51003&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a51003",
  null
  
)

export default component.exports